import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=1b951c84&scoped=true"
import script from "./Quantity.vue?vue&type=script&lang=js"
export * from "./Quantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b951c84",
  null
  
)

export default component.exports